import { useTheme } from 'next-themes';

export const useHeatMapColors = () => {
  const { theme, resolvedTheme } = useTheme();

  // 确定当前使用的主题
  const currentTheme = resolvedTheme || theme;

  const getHeatMapColors = () => {
    if (typeof window === 'undefined') {
      // SSR 时的默认颜色
      return {
        base: '#f3f4f6',
        level1: '#fed7d7',
        level2: '#feb2b2',
        level3: '#fc8181',
        level4: '#f56565',
        level5: '#e53e3e'
      };
    }

    // 从CSS变量获取颜色
    const getComputedColor = (variable: string) => {
      return getComputedStyle(document.documentElement)
        .getPropertyValue(variable)
        .trim();
    };

    return {
      base: getComputedColor('--color-heatmap-base'),
      level1: getComputedColor('--color-heatmap-level1'),
      level2: getComputedColor('--color-heatmap-level2'),
      level3: getComputedColor('--color-heatmap-level3'),
      level4: getComputedColor('--color-heatmap-level4'),
      level5: getComputedColor('--color-heatmap-level5'),
    };
  };

  const colors = getHeatMapColors();

  // 返回颜色对象，用于HeatMap组件
  const panelColors = {
    0: colors.base,
    1: colors.level1,
    2: colors.level2,
    3: colors.level3,
    4: colors.level4,
    5: colors.level5
  };

  return {
    colors,
    panelColors,
    currentTheme
  };
};
